import React, { Dispatch, SetStateAction } from "react";
import Ftsize from "./Ftsize";
import Ftstyle from "./Ftstyle";
import Ftalign from "./Ftalign";
import Insert from "./Insert";
import { NavigateFunction } from "react-router-dom";
import { AppDispatch } from "../../../..";

type Props = {
  setIsUp: React.Dispatch<
    React.SetStateAction<{
      status: boolean;
      type: string;
    }>
  >;
  status: "new" | "fix";
  navigate: NavigateFunction;
  type: "project" | "meetup" | "notice";
  __insert: () => void;
  Save: ((e: string | undefined) => void) | undefined;
  dispatch: AppDispatch;
  setIsLook?: Dispatch<SetStateAction<boolean>>;
  SaveTemplate?: (e: string) => void;
};

/** 에디터 헤더 */
function EdiHeader({
  setIsUp,
  navigate,
  type,
  __insert,
  status,
  Save,
  dispatch,
  setIsLook,
  SaveTemplate,
}: Props) {
  return (
    <div className="edit-header">
      <Ftsize />
      <div className="line" />
      <Ftstyle />
      <div className="line" />
      <Ftalign />
      <div className="line" />
      <Insert setIsUp={setIsUp} dispatch={dispatch} />
      <div className="btn-wrapper">
        <div className="left">
          {type !== "notice" ? (
            <>
              {status === "new" ? (
                <button
                  className="save"
                  onClick={() => {
                    if (Save) {
                      const template = document.getElementById("screen");
                      if (template) {
                        Save(template.innerHTML);
                      }
                    }
                  }}
                >
                  임시저장
                </button>
              ) : undefined}
              <button
                className="look"
                onClick={() => {
                  if (setIsLook) {
                    setIsLook(true);
                  }
                }}
              >
                미리보기
              </button>
            </>
          ) : undefined}
        </div>
        <div className="right">
          <button
            className="back"
            onClick={() => {
              const template = document.getElementById("screen");
              if (template && SaveTemplate) {
                SaveTemplate(template.innerHTML);
              }
              setTimeout(() => {
                navigate(-1);
              }, 100);
            }}
          >
            <img src="/assets/editor/arrow.svg" alt="" />
            이전으로
          </button>
          <button className="init" onClick={__insert}>
            등록완료
          </button>
        </div>
      </div>
    </div>
  );
}

export default EdiHeader;
